import { Injectable } from '@angular/core';
import { AuthUtilsService } from '@app/auth/services/auth-utils.service';
import { AuthenticationService } from '@app/auth/services/authentication.service';
import { ToastService } from '@app/portal/services/toast-service';
import { CommandDefinition, CommandHelper } from '@app/shared/quick-commands';
import { PossibleShortcut } from '@app/shared/services/hotkey.service';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LogoutCommand implements CommandDefinition<any> {
  countInvocations = false;
  hotkey: PossibleShortcut = 'control.l';
  icon = 'far fa-lock';
  label = 'quickCommands.commands.logout';
  name = 'Logout';

  constructor(
    private authenticationService: AuthenticationService,
    private authUtilsService: AuthUtilsService,
    private toastService: ToastService,
    private translateService: TranslateService
  ) {}

  action() {
    return this.authenticationService.logout().pipe(
      map(() => {
        this.toastService.success(this.translateService.instant('quickCommands.commands.logout.success'));
        this.authUtilsService.redirectToLogin();
        return CommandHelper.close();
      })
    );
  }
}
